var jianguan = [
    "珠海市公路事务中心", "珠海高速公路运营有限公司", "广东华政建设有限公司", "珠海市桥隧养护中心", "港珠澳大桥珠海连接线管理中心", "珠海兴格投资有限公司", "珠海市交通运输安全事务中心"
];
var lydz = {
    richangbaojie: [
        /* {
            title: "监管单位",
            key: "dept",
            type: "Select",

            required: false,
            selectItems: jianguan,
            filterable: true,
            allowCreate: true,
        }, */
        {
            title: "项目名称",
            key: "groupId",
            key1: "groupName",
            type: "selectGroup",
            required: true,
        },
        {
            title: "养护单位",
            key: "unit",
            type: "Select",
            selectItems: [
               "广东华政建设有限公司","珠海虹筑建设有限公司", "广东威恒建设工程有限公司", "广东信婷建设劳务有限公司", "珠海德康泰实业有限公司", "广东致盛建设工程有限公司", "珠海锦裕劳务有限公司", "广东程达路桥有限公司", "东部大桥项目",
            ],
            filterable: true,
            allowCreate: true,
        },
        {
            title: "养护项目",
            key: "itemList",
            type: "Select",
            selectItems: [
                "全线日常保洁、洗扫",
                "全线日常巡查",
                "夜巡视",
                "清洗全线伸缩缝",
                "清理疏通全线排水沟、泄水孔",
                "清理疏通积水点",
                "清洗标志标牌、防撞墙、水马等交安附属设施",
                "全线绿化浇水",
                "全线绿化除草、修剪、杀虫",
                "全线绿化施肥",
                "路面洒水清洗",
            ],
            multiple: true,
            required: true,
            filterable: true,
            allowCreate: true,
            show: 'arr'
        },
        {
            title: "作业地点",
            key: "address",
            type: "Input",
            required: true,
        },
        {
            title: "作业日期",
            key: "time",
            key2: "time2",
            type: "lyyymmdd",
            required: true,
            show: 'yymmdd'
        },
        {
            title: "起止桩号",
            key: "pileNoList",
            selectItems: ["全线快车道", "全线慢车道", "全线应急车道"],
            multiple: true,
            type: "Select",
            required: true,
            show: 'arr',
            filterable: true,
            allowCreate: true,
        },
        {
            title: "班组长",
            key: "workerId",//不传后台
            key1: "workerLeader",//传后台
            type: "selectUser",
            required: true,
        },
        {
            title: "派工人员",
            key: "dispatcher",
            type: "Input",
            required: true,
        },
    ],
    richangxuncha: [
        /* {
            title: "监管单位",
            key: "dept",
            type: "Select",

            required: false,
            selectItems: jianguan,
            filterable: true,
            allowCreate: true,
        }, */
        {
            title: "项目名称",
            key: "groupId",
            key1: "groupName",
            type: "selectGroup",
            required: true,
        },
        {
            title: "养护单位",
            key: "unit",
            type: "Select",
            selectItems: [
                "广东华政建设有限公司","珠海虹筑建设有限公司", "广东威恒建设工程有限公司", "广东信婷建设劳务有限公司", "珠海德康泰实业有限公司", "广东致盛建设工程有限公司", "珠海锦裕劳务有限公司", "广东程达路桥有限公司", "东部大桥项目",
            ],
            filterable: true,
            allowCreate: true,
        },
        {
            title: "巡查项目",
            key: "itemList",
            type: "Select",
            selectItems: [
                "全线日常保洁、洗扫",
                "全线日常巡查",
                "夜巡视",
                "清洗全线伸缩缝",
                "清理疏通全线排水沟、泄水孔",
                "清理疏通积水点",
                "清洗标志标牌、防撞墙、水马等交安附属设施",
                "全线绿化浇水",
                "全线绿化除草、修剪、杀虫",
                "全线绿化施肥",
                "路面洒水清洗",
            ],
            multiple: true,
            required: true,
            filterable: true,
            allowCreate: true,
            show: 'arr'
        },
        {
            title: "作业地点",
            key: "address",
            type: "Input",
            required: true,
        },
        {
            title: "作业日期",
            key: "time",
            key2: "time2",
            type: "lyyymmdd",
            required: true,
            show: 'yymmdd'
        },
        {
            title: "起止桩号",
            key: "pileNoList",
            selectItems: ["全线快车道", "全线慢车道", "全线应急车道"],
            multiple: true,
            type: "Select",
            required: true,
            show: 'arr',
            filterable: true,
            allowCreate: true,
        },
        {
            title: "班组长",
            key: "workerId",//不传后台
            key1: "workerLeader",//传后台
            type: "selectUser",
            required: true,
        },
        {
            title: "派工人员",
            key: "dispatcher",
            type: "Input",
            required: true,
        },
    ],
    yingjijiuyuan: [
        {
            title: "监管单位",
            key: "dept",
            type: "Select",
            required: false,
            selectItems: jianguan,
            filterable: true,
            allowCreate: true,
        },
        {
            title: "项目名称",
            key: "groupId",
            key1: "groupName",
            type: "selectGroup",
            required: true,
        },
        {
            title: "养护单位",
            key: "unit",
            type: "Select",
            selectItems: [
                "珠海虹筑建设有限公司", "广东威恒建设工程有限公司", "广东信婷建设劳务有限公司", "珠海德康泰实业有限公司", "广东致盛建设工程有限公司", "珠海锦裕劳务有限公司", "广东程达路桥有限公司", "东部大桥项目",
            ],
            filterable: true,
            allowCreate: true,
        },
        {
            title: "养护项目",
            key: "itemList",
            type: "Select",
            selectItems: [
                "全线日常保洁、洗扫",
                "全线日常巡查",
                "夜巡视",
                "清洗全线伸缩缝",
                "清理疏通全线排水沟、泄水孔",
                "清理疏通积水点",
                "清洗标志标牌、防撞墙、水马等交安附属设施",
                "全线绿化浇水",
                "全线绿化除草、修剪、杀虫",
                "全线绿化施肥",
                "路面洒水清洗",
            ],
            multiple: true,
            required: true,
            filterable: true,
            allowCreate: true,
            show: 'arr'
        },
        {
            title: "作业地点",
            key: "address",
            type: "Input",
            required: true,
        },
        {
            title: "作业日期",
            key: "time",
            key2: "time2",
            type: "lyyymmdd",
            required: true,
            show: 'yymmdd'
        },
        {
            title: "起止桩号",
            key: "pileNoList",
            selectItems: ["全线快车道", "全线慢车道", "全线应急车道"],
            multiple: true,
            type: "Select",
            required: true,
            show: 'arr',
            filterable: true,
            allowCreate: true,
        },
        {
            title: "班组长",
            key: "workerId",//不传后台
            key1: "workerLeader",//传后台
            type: "selectUser",
            required: true,
        },
        {
            title: "派工人员",
            key: "dispatcher",
            type: "Input",
            required: true,
        },
    ],
    gaoweizuoye: [
        {
            title: "项目名称",
            key: "name",
            key1: "name",
            type: "Input",
            required: true,
        },
        {
            title: "单位名称",
            key: "groupId",
            key1: "groupName",
            type: "selectGroup",
            required: true,
        },
        {
            title: "作业地点",
            key: "address",
            key1: "address",
            type: "Input",
            required: false,
        },
        {
            title: "作业时间",
            key: "time",
            key2: "time2",
            type: "lyyymmdd",
            required: false,
            show: 'yymmdd'
        },
        {
            title: "作业内容",
            key: "itemList",
            key1: "itemList",
            selectItems: ["桥梁抢修", "吊装重物"],
            type: "Select",
            multiple: true,
            required: true,
            filterable: true,
            allowCreate: true,
            show: 'arr'
        }, {
            title: "服务模块",
            key: "content",
            key1: "content",
            type: "Input",
        },
        {
            title: "作业人数",
            key: "peopleNum",
            type: "InputNumber",
            required: false,
        },
        /* {
            title: "监管人员",
            key: "supervisor",
            type: "selectPerson",
            required: true,
        }, */
        {
            title: "监管人员",
            //key: "supervisor",
            key: "supervisorId",//不传后台
            key1: "supervisor",//传后台
            type: "selectUser",
            required: true,
        },
        {
            title: "危险环节",
            key: "linkList",
            selectItems: ["高空/登高作业", "超大重异形吊、运", "密闭/有限空间作业", "易燃易爆作业", "临时作业", "高压电气作业", "维修调试作业", "动火作业", "涉及重大危险源/场所作业"],
            type: "Select",
            multiple: true,
            filterable: true,
            allowCreate: true,
            span: 24,
            required: false,
            show: 'arr'
        },
        {
            title: "危险因素",
            key: "factorList",
            key1: "factors",
            selectItems: ["施工地车流大", "施工地周边易燃物较多"],
            type: "Select",
            multiple: true,
            filterable: true,
            allowCreate: true,
            span: 24,
            required: false,
            show: 'arr'
        },
        {
            title: "防控措施",
            key: "measureList",
            key1: "measureList",
            selectItems: ["道路封控", "远离易燃物，配备灭火设施"],
            type: "Select",
            multiple: true,
            filterable: true,
            allowCreate: true,
            span: 24,
            required: false,
            show: 'arr'
        },
        {
            title: "专项方案审批",
            key: "approveFileList",
            key1: "approveFileList",
            slot: "approveFileList",
            type: "lyPhoto",
            required: false,
            show: 'photo'
        },
        {
            title: "安全技术交底",
            key: "handoverFileList",
            slot: "handoverFileList",
            key1: "handoverFileList",
            type: "lyPhoto",
            required: false,
            show: 'photo'
        },

    ],
    xiaoxiuzuoye: [
        {
            title: "监管单位",
            key: "dept",
            type: "Select",
            required: false,
            selectItems: jianguan,
            filterable: true,
            allowCreate: true,
        },
        {
            title: "项目名称",
            key: "groupId",
            key1: "groupName",
            type: "selectGroup",
            required: true,
        },
        {
            title: "养护单位",
            key: "unit",
            type: "Select",
            selectItems: [
                "珠海虹筑建设有限公司", "广东威恒建设工程有限公司", "广东信婷建设劳务有限公司", "珠海德康泰实业有限公司", "广东致盛建设工程有限公司", "珠海锦裕劳务有限公司", "广东程达路桥有限公司", "东部大桥项目",
            ],
            filterable: true,
            allowCreate: true,
        },
        {
            title: "作业项目",
            key: "itemList",
            selectItems: ["修复路面", "修复护栏"],
            type: "Select",
            multiple: true,
            required: true,
            filterable: true,
            allowCreate: true,
            span: 24,
            show: 'arr'
        },
        {
            title: "作业地点",
            key: "address",
            type: "Input",
            required: true,
        },
        {
            title: "作业日期",
            key: "time",
            key2: "time2",
            type: "lyyymmdd",
            required: true,
            show: 'yymmdd'
        },
        {
            title: "起止桩号",
            key: "pileNoList",
            selectItems: ["全线快车道", "全线慢车道", "全线应急车道"],
            multiple: true,
            type: "Select",
            required: false,
            show: 'arr',
            filterable: true,
            allowCreate: true,
        },
        {
            title: "班组长",
            key: "workerId",//不传后台
            key1: "workerLeader",//传后台
            type: "selectUser",
            required: true,
        },
        {
            title: "派工人员",
            key: "dispatcher",
            type: "Input",
            required: true,
        },
        {
            title: "高危作业附件",
            key: "applyId",
            slotForm: 'fujian',
            open: 'applyNo',
            required: false,
        },
    ],
    dailyRecord: [
        {
            title: "保洁内容",
            key: "item",
            key1: "item",
            type: "Select",
            required: true,
        },
        {
            title: "单位",
            key: "unit",
            key1: "unit",
            type: "Select",
            required: true,
        },
        {
            title: "数量",
            key: "number",
            key1: "number",
            slot: 'number',
            type: "InputNumber",
            required: true,
        },
        {
            title: "实施时间",
            key: "time",
            key1: "time",
            slot: 'time',
            type: "lyyymmdd",
            required: true,
        },
        {
            title: "完成情况",
            key: "progress",
            key1: "progress",
            slot: 'progress',
            type: "Input",
            required: true,
        },
    ],
    nightRecord: [
        {
            title: "巡查内容",
            key: "item",
            key1: "item",
            type: "Select",
            required: true,
            show: 'arr'
        },
        {
            title: "巡查人",
            key: "inspector",
            key1: "inspector",
            type: "Input",
            required: true,
        },
        {
            title: "巡查类型",
            key: "type",
            key1: "type",
            type: "Select1",
            selectKey: 'checkType',
            required: true,
        },
        {
            title: "巡查时间",
            key: "time",
            key1: "time",
            type: "lyyymmdd",
            required: true,
        },

    ],
    qianzi: [
        {
            title: "工单号",
            key: "title",
            key1: "title",
            type: "Input",
            span: 24,
            readonly: true,
            required: true,
        },
        {
            title: "职务",
            key: "job",
            key1: "job",
            type: "Input",
            span: 24,
            required: true,
            readonly: true,
        },
        {
            title: "签字",
            key: "name",
            key1: "name",
            type: "Input",
            span: 24,
            required: true,
            readonly: true
        },
        {
            title: "处理意见",
            key: "opinion",
            key1: "opinion",
            type: "Input",
            span: 24,
            required: true,
        },
        {
            title: "签字日期",
            key: "time",
            key1: "time",
            type: "lyyymmdd",
            span: 24,
            required: true,
        },

    ],
    yanshou: [
        {
            title: "名称",
            key: "name",
            type: "Input",
            required: true,
        },
        {
            title: "开始日期",
            key: "startTime",
            key1: "startTime",
            type: "lyyymmdd",
            required: true,
            show: 'yymmdd'
        },
        {
            title: "结束日期",
            key: "endTime",
            key1: "endTime",
            type: "lyyymmdd",
            required: true,
            show: 'yymmdd'
        },
        {
            title: "验收项目",
            key: "itemList",
            key1: "itemList",
            type: "Select",
            multiple: true,
            disabled: true,
            required: true,
            show: 'arr'
        },
        {
            title: "工程量",
            key: "content",
            key1: "content",
            type: "Input",
            type1: "textarea",
        },
        {
            title: "备注信息",
            key: "remark",
            key1: "remark",
            type: "Input",
            type1: "textarea",
        },
    ]
};

export default lydz;


// WEBPACK FOOTER //
// ./src/components/yhgl/forms/fields.js